// EtiquetasXL persistence - S47.2.
// Persistencia minima del estado del editor en localStorage.
// Schema versionado para evitar romper plantillas viejas en migraciones.
//
// Shape persistida:
//   { v: 1, sizeId: string, fields: Field[] }
//
// Field shape (tal cual lo guarda useEtiquetaEditor):
//   { id, type, xMm, yMm, wMm, hMm, bindKey?, text? }

const STORAGE_KEY = 'xl.etiquetas.editor.v1';
const SCHEMA_VERSION = 1;

function _hasLocalStorage() {
  try {
    return typeof window !== 'undefined' && !!window.localStorage;
  } catch (_e) {
    return false;
  }
}

export function saveState(state) {
  if (!_hasLocalStorage()) return false;
  if (!state || typeof state !== 'object') return false;
  try {
    const payload = {
      v: SCHEMA_VERSION,
      sizeId: state.sizeId || null,
      fields: Array.isArray(state.fields) ? state.fields : [],
    };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
    return true;
  } catch (_e) {
    return false;
  }
}

export function loadState() {
  if (!_hasLocalStorage()) return null;
  let raw = null;
  try {
    raw = window.localStorage.getItem(STORAGE_KEY);
  } catch (_e) {
    return null;
  }
  if (!raw) return null;
  let obj = null;
  try {
    obj = JSON.parse(raw);
  } catch (_e) {
    return null;
  }
  if (!obj || typeof obj !== 'object') return null;
  if (obj.v !== SCHEMA_VERSION) return null;
  return {
    sizeId: typeof obj.sizeId === 'string' ? obj.sizeId : null,
    fields: Array.isArray(obj.fields) ? obj.fields : [],
  };
}

export function clearState() {
  if (!_hasLocalStorage()) return false;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
    return true;
  } catch (_e) {
    return false;
  }
}
